import { cx } from '../../lib/cx';
import { useSyncState } from '../../lib/data';
import styles from './SyncIndicator.module.css';

/** One quiet line about where the data stands: saved, syncing, or waiting for the network. */
export function SyncIndicator() {
  const { state, pending } = useSyncState();
  const waiting =
    pending > 0 ? ` · ${pending} ${pending === 1 ? 'modifica' : 'modifiche'} da inviare` : '';

  const text =
    state === 'offline'
      ? `Offline${waiting}`
      : state === 'error'
        ? `Sincronizzazione non riuscita${waiting}`
        : state === 'syncing' && pending > 0
          ? 'Sincronizzazione…'
          : pending > 0
            ? `Salvato sul dispositivo${waiting}`
            : 'Tutto salvato';

  return (
    <p
      className={cx(
        styles.indicator,
        state === 'offline' && styles.offline,
        state === 'error' && styles.error,
      )}
      role="status"
      aria-live="polite"
    >
      <span className={styles.dot} aria-hidden="true" />
      <span className={styles.text}>{text}</span>
    </p>
  );
}
